module.exports = __webpack_public_path__ + "static/media/pause.d75bac3a.svg";